import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
    selector: 'app-generic-dialog',
    imports: [MatDialogModule, CommonModule, MatButtonModule],
    template: `
    @if (data.title) {
      <h2 mat-dialog-title>{{ data.title }}</h2>
    }
    <mat-dialog-content>
      @if (data.message) {
        <p [innerHTML]="formatMessage(data.message)"></p>
      } @else {
        <ng-container *ngComponentOutlet="data.component"></ng-container>
      }
    </mat-dialog-content>
    <mat-dialog-actions>
      @if (data.cancelButtonText) {
        <button mat-button (click)="onCancel()">
          {{ data.cancelButtonText }}
        </button>
      }
      @if (data.confirmButtonText) {
        <button mat-button color="primary" (click)="onConfirm()">
          {{ data.confirmButtonText }}
        </button>
      }
    </mat-dialog-actions>
    `,
    styleUrls: ['./dialog.scss']
})
export class GenericDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<GenericDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      title?: string,
      message?: string,
      component?: any,
      confirmButtonText?: string,
      cancelButtonText?: string
    }
  ) {}

  ngOnInit(): void {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onClose(): void {
    this.dialogRef.close();
  }

 formatMessage(message: string): string {
    if (!message) return '';

    return message
      .replace(/\r\n/g, '<br>')  // Windows line endings
      .replace(/\n/g, '<br>')    // Unix line endings
      .replace(/\r/g, '<br>');   // Mac line endings
  }
}